import React from "react";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import { IRoute } from "src/common/typings/routes";

interface Props {
  subRoutes: IRoute[];
  path: string;
}

export function ModuleRouter({ subRoutes }: Props): React.ReactElement {
  const match = useRouteMatch();
  const mainPage =
    subRoutes.length && Boolean(localStorage.getItem("nodUserMenus"))
      ? match.path === "/unauthorized"
        ? "/unauthorized"
        : JSON.parse(localStorage.getItem("nodUserMenus") || "")?.find(
            (menuItem: any) => menuItem.routeName === match.path
          )?.childMenus[0]?.routeName
      : match.path === "/auth"
      ? "/login"
      : "";
  return (
    <Switch>
      {subRoutes?.map((route, i) => (
        <Route
          key={i}
          path={match.path + route.path + (route.pathParam || "")}
          component={route.component}
        />
      ))}
      <Redirect to={{ pathname: match.path + mainPage }} />
    </Switch>
  );
}
